import type { NextPage, GetServerSidePropsContext } from 'next';
import CES2025 from '@elem/compPage/CES2025';
import { ProductProvider } from '@elem/compPage/CES2025/ProductProvider';
import { IPageStatus } from '@elem/compPage/CES2025/config/IPageStatus';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import seoconfig from '@/seoconfig/ces2025';
import { redirectTo404 } from '@/utils';

// 路由跳转白名单
const whiteLocaleList = ['us'];
// 四端设计稿的页面都在@elem/compPage下，如CES2025
const CES2025Ecoflow: NextPage = ({ SEO, timeLine, pageStatus }: any) => {
    const { t } = useLang('ces2025');
    const { locale } = getLocal();

    const initState = {
        timeLine,
        pageStatus,
    };

    return (
        <PageLayout theme="black">
            <SEO
                title={pageStatus === 'statusA' ? t('seo_title') : t('seo_launch_title')}
                description={pageStatus === 'statusA' ? t('seo_desc') : t('seo_launch_desc')}
            />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={seoconfig.url} />
            <ProductProvider state={initState}>
                <CES2025 />
            </ProductProvider>
        </PageLayout>
    );
};

export default CES2025Ecoflow;

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    console.log(locale, query);
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/CES2025/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/CES2025/config/times/us.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    // 时间节点判断 正式环境未开始重定向404
    const time = new Date().getTime(); // 服务器时区北京时区

    let currentTime = time;
    let pageStatus = currentTime >= timeLine.statusB.start ? IPageStatus.statusB : currentTime >= timeLine.statusA.start ? IPageStatus.statusA : '';

    if (_timer) {
        currentTime = new Date(`${_timer} GMT+8`).getTime();
    }

    if (timeLine) {
        if (currentTime >= timeLine.statusB.start) {
            pageStatus = IPageStatus.statusB;
        } else if (currentTime >= timeLine.statusA.start) {
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }
    if (debug && !_timer) {
        if (debug === IPageStatus.statusA) {
            pageStatus = IPageStatus.statusA;
        } else if (debug === IPageStatus.statusB) {
            pageStatus = IPageStatus.statusB;
        } else {
            return redirectTo404();
        }
    }

    return {
        props: {
            timeLine: timeLine,
            pageStatus: pageStatus,
        },
    };
}
